import { render } from "./GalleryCarousel.vue?vue&type=template&id=34864e16&scoped=true"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js"

import "./GalleryCarousel.vue?vue&type=style&index=0&id=34864e16&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34864e16"]])

export default __exports__